// const AdminLayout = () => import('@/layouts/AdminLayout');
const Index = () => import("./index");
const FairstonePlansList = () => import("./components/Listing");
const Create = () => import("./components/Create");
const Edit = () => import("./components/Edit");
const Permission = () => import("./components/Permission");

import auth from "@/router/middleware/auth";
import maintenance from "@/router/middleware/maintenance";
import isAdmin from "@/router/middleware/isAdmin";

const fairstonePlansRoute = {
  path: "fairstone-plans",
  meta: { label: "Fairstone plans" },
  component: Index,
  children: [
    {
      path: ":siteId",
      name: "fairstone-plans-list",
      meta: {
        label: "All Plans",
        controlLink: "fairstone-plans-list",
        module: "fairstonePlansManager",
        moduleMenuId: "fairstonePlansMenu",
        moduleLabel: "Fairstone Plans Manager",
        middleware: [maintenance, auth, isAdmin],
      },
      component: FairstonePlansList,
    },
    {
      path: ":siteId/:productId/edit",
      name: "edit-fairstone-plans",
      meta: {
        label: "Edit Plan",
        controlLink: "editPlanLink",
        module: "fairstonePlansManager",
        moduleMenuId: "fairstonePlansMenu",
        moduleLabel: "Fairstone Plans Manager",
        middleware: [maintenance, auth, isAdmin],
      },
      component: Edit,
    },
    {
      path: "create",
      name: "create-fairstone-plans",
      meta: {
        label: "Add New Plan",
        controlLink: "create-fairstone-plans",
        module: "fairstonePlansManager",
        moduleMenuId: "fairstonePlansMenu",
        moduleLabel: "Fairstone Plans Manager",
        middleware: [maintenance, auth, isAdmin],
      },
      component: Create,
    },
    {
      path: "permission",
      name: "fairstone-plans-permissions",
      meta: {
        label: "Permission",
        controlLink: "fairstone-plans-permission",
        module: "fairstonePlansManager",
        moduleMenuId: "fairstonePlansMenu",
        moduleLabel: "Fairstone Plans Manager",
        middleware: [maintenance, auth, isAdmin],
      },
      component: Permission,
    },
  ],
};

export default fairstonePlansRoute;
